import { useEffect, useRef, useState } from "react"
import { ScheduleEditJustification } from "./edit/schedule-edit-justification"
import { useComparisonSchedule } from "./edit/useComparisonSchedule"
import { htmlToText } from "lib/html-to-text"
import { normalizeActions } from "library/normalizeActions.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useGetChangeTypeAudits } from "./my-schedules/my-custom-schedules/lib/use-get-changeType-audits"
import { Bound } from "lib/@components/binding/Bound"

export function JustifyIntroductionChanged({ item = { taskId: "intro" } }) {
    const { editMode, target, schedule, referenceId, draftId } = useBoundContext()
    const [isEdit, setIsEdit] = useState(false)
    const [isDialogVisible, setIsDialogVisible] = useState(false)
    const comp = useComparisonSchedule()
    const compare = Array.isArray(comp) ? comp[0] : comp || null
    const comparedTo = useRef({ content: "", note: "" })
    const changeType = "intro"

    const { createdDate, createdBy, latestReason, loading, auditId } = useGetChangeTypeAudits(
        referenceId ?? "",
        changeType,
        draftId,
        "intro"
    )
    const { taskId } = item
    useEffect(() => {
        const baselineIntro = compare?.intro ?? schedule?.intro ?? {}
        comparedTo.current = {
            content: normTextFromHtml(baselineIntro.content ?? ""),
            note: normTextFromHtml(baselineIntro.note ?? ""),
        }
    }, [compare?.id, compare?.version, schedule?._id, schedule?.version, compare?.intro, schedule?.intro])

    const current = {
        content: normTextFromHtml(target?.intro?.content),
        note: normTextFromHtml(target?.intro?.note),
    }

    const hasChanged = current.content !== comparedTo.current.content || current.note !== comparedTo.current.note

    return (
        <Bound
            createdDate={createdDate}
            createdBy={createdBy}
            hasChanged={hasChanged}
            editMode={editMode}
            item={item}
            isDialogVisible={isDialogVisible}
            setIsDialogVisible={setIsDialogVisible}
            latestReason={latestReason}
            loading={loading}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            taskId={taskId}
            original={{ intro: comparedTo.current }}
            tailored={{ intro: current }}
            changeType={changeType}
            auditId={auditId}
        >
            <ScheduleEditJustification />
        </Bound>
    )

    function normTextFromHtml(html) {
        return htmlToText(normalizeActions(html || ""))
    }
}
